function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { DrmType } from '../../../../core/player/playout-data';
import { isPs4 } from '../../../../utils/device-type';
import { PlaybackTypeKey } from '../../../../utils/playback-vendor-relation';
import { getShakaAbrFactory } from '../../../../players/shaka/abr/shaka-abr-factory';
var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9, _obj10;
export var oneAppShakaConfig = {
    getAbrFactory: function(shakaInstance, playbackType, abrConfig) {
        return getShakaAbrFactory(shakaInstance, playbackType, abrConfig);
    },
    streaming: (_obj7 = {}, _define_property(_obj7, DeviceType.Browser, {
        deviceModelDefault: (_obj = {}, _define_property(_obj, PlaybackTypeKey.LINEAR, {
            bufferingGoal: 60,
            // max buffer in seconds
            bufferBehind: 12,
            // buffer maintained in memory from the past
            rebufferingGoal: 0
        }), // min buffer before playback
        _define_property(_obj, PlaybackTypeKey.VOD, {
            bufferingGoal: 60,
            bufferBehind: 4,
            rebufferingGoal: 4.1
        }), _obj)
    }), // Resume or start playback once 3 fragments are downloaded. Setting 4.1 minimises the chances of a 4th fragment being downloaded before play if we start partway through a fragment
    _define_property(_obj7, DeviceType.XboxOne, {
        deviceModelDefault: (_obj1 = {}, _define_property(_obj1, PlaybackTypeKey.LINEAR, {
            bufferingGoal: 30,
            bufferBehind: 6,
            rebufferingGoal: 3.5
        }), _define_property(_obj1, PlaybackTypeKey.VOD, {
            bufferingGoal: 30,
            bufferBehind: 4,
            rebufferingGoal: 4.1
        }), _obj1)
    }), _define_property(_obj7, DeviceType.XboxSeries, {
        deviceModelDefault: (_obj2 = {}, _define_property(_obj2, PlaybackTypeKey.LINEAR, {
            bufferingGoal: 30,
            bufferBehind: 6,
            rebufferingGoal: 3.5
        }), _define_property(_obj2, PlaybackTypeKey.VOD, {
            bufferingGoal: 30,
            bufferBehind: 4,
            rebufferingGoal: 4.1
        }), _obj2)
    }), _define_property(_obj7, DeviceType.Chromecast, {
        deviceModelDefault: (_obj3 = {}, _define_property(_obj3, PlaybackTypeKey.LINEAR, {
            rebufferingGoal: 4.1,
            bufferBehind: 5
        }), _define_property(_obj3, PlaybackTypeKey.VOD, {
            rebufferingGoal: 6,
            bufferBehind: 5
        }), _obj3)
    }), _define_property(_obj7, DeviceType.Tizen, {
        deviceModelDefault: (_obj4 = {}, _define_property(_obj4, PlaybackTypeKey.LINEAR, {
            bufferingGoal: 30,
            bufferBehind: 6,
            rebufferingGoal: 4.1,
            enableSegmentStartWorkaround: true
        }), _define_property(_obj4, PlaybackTypeKey.VOD, {
            bufferingGoal: 30,
            bufferBehind: 7,
            rebufferingGoal: 7,
            enableSegmentStartWorkaround: true
        }), _obj4)
    }), _define_property(_obj7, DeviceType.Prospero, {
        // set rebufferingGoal to 0 because playbackRate=0 isn't supported
        // which is effectively the same as rebufferingGoal=0
        deviceModelDefault: (_obj5 = {}, _define_property(_obj5, PlaybackTypeKey.LINEAR, {
            rebufferingGoal: 0
        }), _define_property(_obj5, PlaybackTypeKey.VOD, {
            rebufferingGoal: 0
        }), _obj5)
    }), _define_property(_obj7, "default", (_obj6 = {}, _define_property(_obj6, PlaybackTypeKey.LINEAR, {
        bufferingGoal: 30,
        bufferBehind: 6,
        rebufferingGoal: 4.1,
        parsePrftBox: true
    }), _define_property(_obj6, PlaybackTypeKey.VOD, {
        bufferingGoal: 30,
        bufferBehind: 7,
        rebufferingGoal: 7
    }), _obj6)), _obj7),
    mediaSource: {},
    abr: {
        default: (_obj8 = {}, _define_property(_obj8, PlaybackTypeKey.LINEAR, {
            switchInterval: 4,
            defaultBandwidthEstimate: 700000
        }), _define_property(_obj8, PlaybackTypeKey.VOD, {
            switchInterval: 2,
            defaultBandwidthEstimate: 700000
        }), _obj8)
    },
    manifest: {
        dash: (_obj10 = {
            default: (_obj9 = {}, _define_property(_obj9, PlaybackTypeKey.VOD, {
                minimumUpdatePeriodOverride: undefined,
                suggestedPresentationDelayOverride: undefined
            }), _define_property(_obj9, PlaybackTypeKey.LINEAR, {
                minimumUpdatePeriodOverride: 24,
                suggestedPresentationDelayOverride: 32
            }), _obj9)
        }, _define_property(_obj10, DeviceType.Browser, _define_property({}, PlaybackTypeKey.LINEAR, {
            minimumUpdatePeriodOverride: 4,
            suggestedPresentationDelayOverride: 8
        })), _define_property(_obj10, DeviceType.XboxOne, _define_property({}, PlaybackTypeKey.LINEAR, {
            minimumUpdatePeriodOverride: 4,
            suggestedPresentationDelayOverride: 8
        })), _define_property(_obj10, DeviceType.XboxSeries, _define_property({}, PlaybackTypeKey.LINEAR, {
            minimumUpdatePeriodOverride: 4,
            suggestedPresentationDelayOverride: 8
        })), _define_property(_obj10, DeviceType.Chromecast, _define_property({}, PlaybackTypeKey.LINEAR, {
            minimumUpdatePeriodOverride: 16,
            suggestedPresentationDelayOverride: 20
        })), _obj10),
        needsExtraDrmInitSegments: _define_property({
            default: function(drmType) {
                return drmType === DrmType.PlayReady;
            }
        }, DeviceType.Prospero, function(drmType, deviceInfo, deviceType) {
            if (!!deviceInfo && !!deviceType && isPs4(deviceInfo, deviceType)) {
                return false;
            }
            return drmType === DrmType.PlayReady;
        })
    }
};

//# sourceMappingURL=shaka-config.js.map